<template>
  <p
    ref="editable"
    contenteditable
    v-on="listeners"></p>
</template>

<script>
  export default {
    name: "editable",
    props: {
      value: {
        type: String,
        default: '',
      },
    },
    computed: {
      listeners() {
        return {...this.$listeners, input: this.onInput};
      },
    },
    mounted() {
      this.$refs.editable.innerText = this.value;
    },
    methods: {
      onInput(e) {
        this.$emit('input', e.target.innerText);
      },
    },
  };
</script>

<style lang="scss">
  [contenteditable]:focus {
    outline: 0px solid transparent !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Base/Editable.vue